import { useEffect, useRef } from 'react';

/**
 * Scroll to element if the location hash matches the element id
 * @param elementId The id of the element to scroll to
 */
export function useScrollToLocationHash(elementId: string) {
  const scrolledToHash = useRef(false);
  const hash = window.location.hash.replace('#', '');

  useEffect(() => {
    if (hash === elementId && !scrolledToHash.current) {
      scrolledToHash.current = scrollToElement(document.getElementById(elementId));
    }
  }, [hash, elementId]);
}

/**
 * Scrolls the specified HTML element into view.
 *
 * @param element - The HTML element to scroll to. If `null`, no scrolling occurs.
 * @returns `true` if the element was scrolled into view, `false` otherwise.
 */
export const scrollToElement = (element: HTMLElement | null) => {
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
    return true;
  }

  return false;
};
